import {
    Box,
    Button,
    Alert,
    Card,
    Container,
    Grid,
    InputAdornment,
    Typography,
    CardContent
  } from '@mui/material';
  import { Helmet } from 'react-helmet';
  import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
  import TextField from '@mui/material/TextField';
  import CustomButton from 'src/components/common/customButton';
  import FormControl from '@mui/material/FormControl';
  import BasicMenu from 'src/components/common/BasicMenu';
  import OutlinedInput from '@mui/material/OutlinedInput';
  import {Download} from 'react-feather';
  import { _axios } from 'src/plugins/axios';
  import commonService from 'src/service/common';
  import React, { useEffect, useState } from 'react';
  
  const menuList = [{
    id: 'employeeId',
    title: 'EmployeeId',
  }]
  let mbUrl = "https://www.medibuddy.in/sl?refurl=corporate&bookingSrc=hrwin&AuthToken="

  function CreateAppointment() {
      const [searchEmpId, setSearchEmpId] = useState('');
      const [url, setUrl] = useState('')
      const [isFound, setIsFound] = useState('temp')
  
      function handleSearch(e){
        _axios.post('ahc/bookAppointment', {employeeId : searchEmpId, service: 1}, {
          ignoreLoading: false,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }).then(response =>{
          if(response.data.isSuccess){
              setUrl(mbUrl+response.data.encryptedToken)
              setIsFound(true)
          } else {
                setUrl('')
                setIsFound(false)
          }
        }).catch(error =>{
            setUrl('')
            setIsFound(false)
        })
      }
    
    return (
      <>
        <Helmet>
          <title>AHC | Repository</title>
        </Helmet>
        <Grid
          container
          sx={{
            width: '100%',
            borderRadius: 4,
            p: 3,
            pt: 2
          }}
        >
          <Grid item xs={12}>
            <Card
              sx={{
                width: '100%',
                borderRadius: 4,
                mb: 2,
                p: 3,
                boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
              }}
            >
              <Grid container>
                <Grid item sx={12} container>
                  <Grid item sm={3}>
                  <FormControl size='small' variant="filled" fullWidth>
                        <OutlinedInput
                          id="outlined-search"
                          sx={{
                            boxShadow: 0,
                            bgcolor: '#f2f2f2'
                          }}
                          labelWidth={0}
                          value={searchEmpId}
                          onChange={(e)=>setSearchEmpId(e.target.value)}
                          placeholder={`Enter EmployeeId`}
                        />
                      </FormControl>
                  </Grid>
                  <Grid item>
                    <Button sx={{ ml:2, px: 3, boxShadow: '0 0 4px rgba(0,0,0,0.20)' }} color="primary"
                          startIcon={<SearchIcon size="18"/>} onClick={handleSearch}
                    > Submit</Button>
                  </Grid>
                      
                      
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        {url && <Grid sx={{pl: 3, mt: -2, height: '80%'}}>
            <iframe style={{borderRadius: '10px'}} width="98%" height="100%" src={url}></iframe>
        </Grid>}
        {!isFound && <Typography xs={3} sx={{ml:'42%', color: 'red'}}>No Employee found</Typography>}
        
      </>
    );
  }
  
  export default CreateAppointment;
  